"use strict";
var appn;
(function (appn) {
    var pubSub;
    (function (pubSub) {
        pubSub.APPN_READY = 'appn.system.ready';
        pubSub.DOM_READY = 'appn.system.domReady';
        pubSub.VIEW_INIT_COMPLETE = 'appn.system.view.init.complete';
        pubSub.WINDOW_RESIZED = 'appn.window.resized';
        pubSub.DESIGNER_PROPS_UPDATED = 'appn.designer.propsUpdated';
        pubSub.START_INTRO = 'appn.startIntro';
        function publishAppnReady() {
            const loadTimeSeconds = new Date(new Date().getTime() - window.appnLoadStart);
            const loadStats = { secs: loadTimeSeconds.getSeconds(), milli: loadTimeSeconds.getMilliseconds() };
            publish(pubSub.APPN_READY, loadStats);
            appn.log.info(loadStats);
        }
        pubSub.publishAppnReady = publishAppnReady;
        function publishDomReady() {
            const domReadySeconds = new Date(new Date().getTime() - window.appnLoadStart);
            const domReadyStats = { secs: domReadySeconds.getSeconds(), milli: domReadySeconds.getMilliseconds() };
            publish(pubSub.DOM_READY, domReadyStats);
            appn.log.info(domReadyStats);
        }
        pubSub.publishDomReady = publishDomReady;
        function publish(channel, data) {
            PubSub.publish(channel, data ? data : appn.emptyString);
        }
        pubSub.publish = publish;
        function publishSync(channel, data) {
            PubSub.publishSync(channel, data ? data : appn.emptyString);
        }
        pubSub.publishSync = publishSync;
        function subscribe(channel, data) {
            PubSub.subscribe(channel, data);
        }
        pubSub.subscribe = subscribe;
        function unSubscribe(channel) {
            PubSub.unsubscribe(channel);
        }
        pubSub.unSubscribe = unSubscribe;
        function clearAllSubscriptions() {
            PubSub.clearAllSubscriptions();
        }
        pubSub.clearAllSubscriptions = clearAllSubscriptions;
    })(pubSub = appn.pubSub || (appn.pubSub = {}));
})(appn || (appn = {}));
